import type { EventProperties } from '@segment/analytics-next';
import { segmentTrackEventExperimentExposed } from './segment-constants';

/**
 * Merges experiment superproperties into Segment `track` payloads.
 * `Experiment Exposed` stays spec-clean (caller supplies `experiment_key`, `variant`, etc.).
 */
export function mergeSegmentTrackEventProperties(
  eventName: string,
  properties: EventProperties | undefined,
  experimentSegmentProperties: EventProperties
): EventProperties {
  if (eventName === segmentTrackEventExperimentExposed) {
    return { ...properties };
  }

  return {
    ...properties,
    ...experimentSegmentProperties
  };
}
